module.exports = "/_next/static/images/7-312d90c29fbca934d611e724b8ea38ff.gif";